import {
  LayoutDashboard,
  Target,
  DollarSign,
  Award,
  Brain,
  Settings,
  Wallet,
  PieChart,
  BarChart3,
  Table,
  HeartPulse,
  Landmark,
  ClipboardList,
  Layers,
  FileBarChart,
  CreditCard,
} from 'lucide-react';

// Macroáreas do ALVO. A navegação é contextual: a lateral mostra APENAS as subáreas
// da macroárea atual. Rotas e páginas permanecem inalteradas.
export const AREAS = [
  {
    id: 'visao-geral',
    label: 'Visão Geral',
    description: 'Panorama completo da empresa.',
    icon: LayoutDashboard,
    color: '#3B82F6',
    items: [
      { path: '/dashboard', icon: LayoutDashboard, label: 'Dashboard' },
      { path: '/saude-financeira', icon: HeartPulse, label: 'Saúde Financeira' },
      { path: '/geral', icon: Layers, label: 'Consolidado' },
    ],
  },
  {
    id: 'planejamento',
    label: 'Planejamento',
    description: 'Metas, orçamento e compromissos.',
    icon: Target,
    color: '#F59E0B',
    items: [
      { path: '/goals', icon: Target, label: 'Metas & Orçamento' },
      { path: '/compromissos', icon: Wallet, label: 'Compromissos' },
    ],
  },
  {
    id: 'financeiro',
    label: 'Financeiro',
    description: 'DRE, caixa, receita e projeções.',
    icon: DollarSign,
    color: '#22C55E',
    items: [
      { path: '/dre', icon: ClipboardList, label: 'DRE' },
      { path: '/caixa', icon: Landmark, label: 'Caixa' },
      { path: '/fluxo-caixa', icon: Table, label: 'Fluxo de Caixa' },
      { path: '/gestao-receita', icon: Layers, label: 'Gestão de Receita' },
      { path: '/roi', icon: PieChart, label: 'ROI' },
      { path: '/projecao', icon: BarChart3, label: 'Projeções' },
    ],
  },
  {
    id: 'performance',
    label: 'Performance',
    description: 'Indicadores e eficiência da empresa.',
    icon: Award,
    color: '#06B6D4',
    items: [
      { path: '/performance', icon: Award, label: 'Performance' },
      { path: '/reports', icon: FileBarChart, label: 'Relatórios' },
    ],
  },
  {
    id: 'diretor-financeiro',
    label: 'Diretor Financeiro',
    description: 'Diagnósticos, análises e recomendações com IA.',
    icon: Brain,
    color: '#8B5CF6',
    items: [
      { path: '/diretor-financeiro', icon: Brain, label: 'Diretor Financeiro' },
    ],
  },
  {
    id: 'configuracoes',
    label: 'Configurações',
    description: 'Preferências e ajustes do sistema.',
    icon: Settings,
    color: '#94A3B8',
    items: [
      { path: '/settings', icon: Settings, label: 'Preferências' },
      { path: '/assinatura', icon: CreditCard, label: 'Assinatura' },
    ],
  },
];

// Retorna o item (subárea) da rota informada.
export const getItemByPath = (pathname) => {
  for (const area of AREAS) {
    const item = area.items.find((it) => pathname === it.path || pathname.startsWith(it.path + '/'));
    if (item) return { area, item };
  }
  return null;
};

// Retorna a macroárea que contém a rota informada (ou null se nenhuma).
export const getAreaByPath = (pathname) =>
  AREAS.find((area) => area.items.some((it) => pathname === it.path || pathname.startsWith(it.path + '/'))) || null;

// Primeira rota de uma macroárea (destino ao clicar no card do hub).
export const getAreaEntryPath = (area) => (area?.items?.[0]?.path || '/areas');
